export function paginate(items, page, perPage){
    // slice items based on pagination
    const from = (page * perPage) - perPage;
    const to = (page * perPage);
    return items.slice(from, to);
}